import React, { useState } from 'react';
import { OfferDetails } from './OfferDetails';
import { SideListHeader } from '../components/ListHeader';
import { ComponentErrorBoundary, toFormattedDate } from '@app/utilities';
import { useOffers } from '@app/sdk';
import { Table } from '@app/shared';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';

export function Offers() {
  const [selectedOffer, setSelectedOffer] = useState(undefined as any);
  const [refreshOffer, setRefreshOffer] = useState<number>(0);

  const { data: offers, isLoading } = useOffers();

  const columDefs: ColDef[] = [
    { field: 'offerId', headerName: 'ID' },
    { field: 'name', headerName: 'Name' },
    { field: 'description', headerName: 'Description' },
    { field: 'startDate', headerName: 'Start Date', valueFormatter: (params) => toFormattedDate(params.value) },
    { field: 'endDate', headerName: 'End Date', valueFormatter: (params) => toFormattedDate(params.value) },
    { field: 'status', headerName: 'Status' },
  ];

  const master = (
    <Segment style={{ height: '100%' }}>
      <SideListHeader>Current Offers</SideListHeader>
      <div style={{ height: 'calc(100% - 70px)' }}>
        <Table items={offers?.offers} onSelectItem={(offer) => setSelectedOffer(offer)} columnDefs={columDefs} />
      </div>
    </Segment>
  );

  const detail = (
    <Segment>
      {selectedOffer ? (
        <OfferDetails offer={selectedOffer} refreshOffer={() => setRefreshOffer(refreshOffer + 1)} />
      ) : (
        <section>Please select an offer</section>
      )}
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && offers && <MasterDetailLayout master={master} detail={detail} />}
    </ComponentErrorBoundary>
  );
}
